import {createAction} from 'redux-actions';

const PENDING_USER_ACTIVITY_CONSIDER = 'PENDING_USER_ACTIVITY_CONSIDER';
const USER_ACTIVITY_CONSIDERED = 'USER_ACTIVITY_CONSIDERED';

export const considerUserActivity = createAction(PENDING_USER_ACTIVITY_CONSIDER);
export const onUserActivityConsidered = createAction(USER_ACTIVITY_CONSIDERED);
export const havePendingActionToConsider = (state) => state.userActivityReducer.needToConsiderUserAction;


const initialState = {
    needToConsiderUserAction: false
};

const userActivityReducer = (state = initialState, action) => {
    switch (action.type) {
        case PENDING_USER_ACTIVITY_CONSIDER : {
            return {needToConsiderUserAction: true};
        }
        case USER_ACTIVITY_CONSIDERED: {
            return {needToConsiderUserAction: false};
        }
        default: {
            return state;
        }
    }
};

export default userActivityReducer;


// WEBPACK FOOTER //
// ./src/reducers/userActivityReducer.js